import {TimelineMax, TweenMax, Sine, Linear} from 'gsap';
const Snap = require('snapsvg');
const body = document.body;
const preloadBlock = document.querySelector('.preloader');
let preloadState = 0;

const SizeMode = require('../utils/SizeMode');
const sizeMode = SizeMode();

body.dataset.loading = true;

let params;

switch (sizeMode) {
    case 'mobile_landscape':
    case 'mobile_portrait':
        params = {
            width: 7.656,
            width1: 400,
            height1: 400,
            num: 45,
            R: 64
        };
        break;

    default:
        params = {
            width: 7.656,
            width1: 768,
            height1: 768,
            num: 45,
            R: 64
        };
        break;
}


let mainTL;
let svg;
let units;
let transforms;


const delta = 0.9;
const min = 0.15;
const max = 1;
const a = 0.025;
const obj = {
    n: 0,
    R: params.R * 0.19,
    max: min,
    min: min
};

const init = function () {

    const preloadCont = document.querySelector('.preloader__wrap');

    svg = Snap(params.width1, params.height1);

    svg.attr({viewBox: `${-params.width1 / 2} ${-params.height1 / 2} ${params.width1} ${params.height1}`});

    preloadCont.appendChild(svg.node);

    _construct(svg);

    _invalidate(svg);

    _animate();

    _show();
};

const _construct = function (svg) {
    const R = params.R * 0.19;
    const a = 180 / params.num;
    let g = svg.g();
    svg.rect(-1.276 / 2, -params.width / 2, 1.276, params.width).appendTo(g);
    g.attr({
        id: 'preloaderUnit'
    });

    g = svg.g().attr({opacity: 0}).append(g);

    let i;
    let r;
    let gr;
    const grs = [svg.g(), svg.g()];
    const els = [];
    const uts = [];
    const trs = [];

    for (i = 0; i < params.num; i++) {
        els.push([]);
        uts.push([]);
        for (let j = 0; j < 2; j++) {
            gr = grs[j];


            g = svg.g();
            // uts[i].push(g);

            r = svg.use('preloaderUnit')
                /* .attr({
                    transform: `scale(1, 2) translate(0, ${params.width * 1.9})`
                })*/
                .appendTo(g);
            els[i].push(r);
            r.attr({fill: j === 1 ? '#00a88d' : '#00a88d'});

            g = svg.g().append(g);
            uts[i].push(g);

            g = svg.g()
                .attr({
                    transform: `translate(0, ${-R})`
                }).append(g);
            trs.push(g);

            g = svg.g()
                .attr({
                    transform: `rotate(${-a * i}, 0, 0)`
                }).append(g).appendTo(gr);
        }
    }
    gr.attr({
        transform: 'rotate(180, 0, 0)'
    });

    units = uts;
    transforms = trs;
};


const _invalidate = () => {

    let x;
    let s;

    units.forEach((arr, i) => {
        x = i + obj.n;
        while (x > params.num)
            x -= params.num;
        s = x < delta ? obj.min + (obj.max - obj.min) * Math.sin(0.5 * Math.PI * x / delta) : Math.max(obj.min, obj.max - a * x);

        arr[0].attr({
            transform: 'scale(1, ' + s + ')'
        });

        arr[1].attr({
            transform: 'scale(1, ' + s + ')'
        });

    });

};

const _animate = () => {
    const tl = new TimelineMax({
        repeat: -1,
        onUpdate: _invalidate
    });
    tl.to(obj, 6, {
        n: params.num,
        ease: Linear.easeInOut
    });

    mainTL = tl;
}

const _updateTransforms = () => {
    transforms.forEach(el => {
        el
            .attr({
                transform: `translate(0, ${-obj.R})`
            });
    });
}

const _show = () => {

    TweenMax.to(obj, 0.8, {
        delay: 0.35,
        max: max,
        ease: Sine.easeInOut
    });

    TweenMax.to(obj, 0.7, {
        delay: 0.15,
        R: params.R * 1.05,
        ease: Sine.easeInOut,
        onUpdate: _updateTransforms,
        onComplete: () => {
            TweenMax.to(obj, 0.4, {
                R: params.R,
                ease: Sine.easeInOut,
                onUpdate: _updateTransforms
            })
        }
    });
}

const _hide = () => {

    TweenMax.to(obj, 0.5, {
        max: min,
        ease: Sine.easeInOut
    });

    TweenMax.to(obj, 0.4, {
        R: params.R * 1.05,
        ease: Sine.easeInOut,
        onUpdate: _updateTransforms,
        onComplete: () => {
            TweenMax.to(obj, 0.4, {
                R: params.R * 0.05,
                ease: Sine.easeInOut,
                onUpdate: _updateTransforms,
                onComplete: () => {
                    mainTL.kill();
                }
            })
        }
    });
}


module.exports.destroy = t => {
    delete body.dataset.loading;
    body.dataset.loaded = 'true';
    body.dataset.loadedTransition = 'true';

    _hide();

	setTimeout(() => {

        if (preloadBlock.parentNode) preloadBlock.parentNode.removeChild(preloadBlock);
		delete body.dataset.loadedTransition;
	}, (t || 1.2) * 1000);
};

module.exports.update = loader => {
    body.dataset.loading = true;

    if (Math.round(loader.progress) > preloadState) {
		preloadState = Math.floor(loader.progress);
    }
};

init();



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/load/Preloader.js